import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@auth/AuthContext';

export interface AuthGuardProps {
  children: React.ReactNode;
}

/**
 * Wraps protected routes. Redirects unauthenticated users to /login,
 * preserving the original destination for post-login redirect.
 * Shows a loading spinner while auth state is being determined.
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
